export default {
    save: state => localStorage.setItem(getToken(), JSON.stringify(state)),
    get: () =>
        localStorage.getItem(getToken())
            ? JSON.parse(localStorage.getItem(getToken()))
            : null,
    clear: () => localStorage.clear(),
}

const getToken = () =>
    document.querySelector('meta[name=csrf-token]').getAttribute('content')
